import { makeFilterParams } from '../../utils/helpers/helpers';
import httpClient from '../httpClient';

const getProjects = async (params) => {
  return await httpClient.get('/postcontractual_selectors/projects/', {
    params: params,
  });
};

const filter = async (
  query = '',
  page = 1,
  pageSize = 10,
  sortBy = '',
  search = false,
  _exportCSV = false,
) => {
  let searchBy = '';

  if (search) searchBy = '&filter[search]=' + search;
  if (sortBy) sortBy = '&sort=' + sortBy;
  return await httpClient.get(
    `/postcontractual/${query}&page[number]=${page}&page[size]=${pageSize}${sortBy}${searchBy}`,
  );
};

const get = async (id) => {
  return await httpClient.get(`/postcontractual/${id}/`);
};

const remove = async (id, data) => {
  return await httpClient.delete(`/postcontractual/${id}/`, { data });
};

const getIMCounters = async (projectId) => {
  return await httpClient.get(`/pc_counters/?filter[proyecto]=${projectId}`);
};

const getCounters = async (projectId) => {
  return await httpClient.get(
    `/postcontractual/counters/?filter[proyecto]=${projectId}`,
  );
};

const post = async (data) => {
  return await httpClient.post('/postcontractual/', data);
};

const put = async (id, data) => {
  return await httpClient.put(`/postcontractual/${id}/`, data);
};

const contractSearch = async (
  query = {},
  page = 1,
  pageSize = 10,
  sortBy = undefined,
  search = false,
  exportCSV = false,
) => {
  const params = makeFilterParams(
    query,
    page,
    pageSize,
    search,
    sortBy,
    exportCSV,
  );
  const url = exportCSV
    ? '/pc_contract_search/export/'
    : '/pc_contract_search/';
  return await httpClient.get(url, params);
};

const contractSearchCounters = async (query = {}) => {
  return await httpClient.get(
    '/pc_contract_search/counters/',
    makeFilterParams(query),
  );
};

const newInfo = async (project_id) => {
  return await httpClient.get(`/postcontractual/${project_id}/new_info/`);
};

const causalSelector = async (filters) => {
  return await httpClient.get('pc_cause_selector', makeFilterParams(filters));
};

const uploadEvidence = async (data) =>
  await httpClient.post('/postcontractual_evidence/', data);

const getEvidence = async (id) =>
  await httpClient.get(`/postcontractual_evidence/${id}`);

const deleteEvidence = async (id) =>
  await httpClient.delete(`/postcontractual_evidence/${id}/`);

const approvedTable = async (
  query = '',
  _page = 1,
  _pageSize = 10,
  _sortBy = 'id',
  search = false,
  _exportCSV = false,
) => {
  let searchBy = '';

  if (search) searchBy = '&filter[search]=' + search;
  return await httpClient.get(
    `ct_postcontractual_signed/?filter[contrato]=${query}${searchBy}`,
  );
};

const previewAct = async (id, data) =>
  await httpClient.patch(`/postcontractual/${id}/preview/`, data);

export {
  filter,
  get,
  remove,
  getCounters,
  post,
  put,
  newInfo,
  causalSelector,
  contractSearch,
  contractSearchCounters,
  approvedTable,
  uploadEvidence,
  getEvidence,
  deleteEvidence,
  previewAct,
  getIMCounters,
  getProjects,
};
